<template>
  <div class="firstPage">
    <div class="economs flex_left">
      <cardsList :userBehaviorData="userBehavior"></cardsList>
      <div class="right_center">
        <div class="center_anonco">
          <div class="git_anonco flex_left">
            <div class="list_h3" style="min-width: 140px">
              <img
                style="width: 24px; height: 23px; display: block; float: left"
                src="@/assets/image/notice.png"
              />
              <h3>公告/动态</h3>
            </div>
            <img
              @click="cord_unit"
              style="width: 23px; height: 23px; cursor: pointer"
              src="@/assets/image/more.png"
            />
          </div>
          <ul class="list_anonco">
            <li
              class="flex_left"
              v-for="(item, index) in Announ_list"
              :key="index"
            >
              <div class="left_anonco" @click="delivst(item.id)">
                <div v-if="item.type == '公告'" class="cen_anonco">
                  {{ item.type }}
                </div>
                <div
                  v-else-if="item.type == '通知'"
                  class="cen_anonco zix_anonco"
                >
                  {{ item.type }}
                </div>
                <p>{{ item.title }}</p>
              </div>
              <p class="right_anonco">{{ item.createTime }}</p>
            </li>
            <div class="listGit" v-if="Announ_list.length == 0">
              <img src="@/assets/image/zanwu.png" />
              <p>暂无数据</p>
            </div>
          </ul>
        </div>
      </div>
    </div>
    <paperFile :userBehaviorData="userBehavior"></paperFile>
    <commends :userBehaviorData="userBehavior"></commends>
    <!-- 停用采编名片 -->
    <disable></disable>
    <!-- 返回到顶部 -->
    <div class="footer">
      <div class="gotop" v-show="gotop" @click="toTop">
        <img style="width: 27px; height: 23px" src="@/assets/image/toTop.png" />
      </div>
    </div>
  </div>
</template>
<script>
import paperFile from "./paperFile/index";
import commends from "./commends/index";
import cardsList from "../components/card_list.vue";
import disable from "../components/disable.vue";
var vm;
export default {
  name: "firstPage",
  data() {
    return {
      gotop: false,
      Announ_list: [],
      card_list: [],
      // 埋点统计参数
      userBehavior: {
        beginTime: "",
        clickName: "",
        device: navigator.userAgent,
        endTime: "",
        pageName: "首页",
        slidingPercentage: 0,
        source: document.referrer,
        userId: JSON.parse(sessionStorage.getItem("userInfo"))
          ? JSON.parse(sessionStorage.getItem("userInfo")).user.id
          : 0,
      },
      // 统计页面滑动比例大于80%
      slidingOver80: false,
    };
  },
  components: { paperFile, commends, cardsList, disable },
  created() {
    vm = this;
    this.userBehavior.beginTime = new Date()
      .toLocaleString()
      .replaceAll("/", "-");
    vm.userBehavior.endTime = "";
    // 进入页面，统计
    vm.$apis.manage.userBehaviorStatistics(this.userBehavior);

    // 窗口焦点状态统计离开页面
    document.addEventListener("visibilitychange", function () {
      console.log(document.visibilityState);
      if (document.visibilityState == "hidden") {
        vm.userBehavior.endTime = new Date()
          .toLocaleString()
          .replaceAll("/", "-");
        vm.$apis.manage.userBehaviorStatistics(vm.userBehavior);
      } else if (document.visibilityState == "visible") {
        vm.userBehavior.beginTime = new Date()
          .toLocaleString()
          .replaceAll("/", "-");
        vm.userBehavior.endTime = "";
        vm.$apis.manage.userBehaviorStatistics(vm.userBehavior);
      }
    });
  },
  mounted() {
    window.addEventListener("scroll", vm.handleScroll, true);
    //公告
    vm.annoud();
    vm.getRegister();
    // 页面加载完毕
    this.$nextTick(() => {
      // 加载完毕
      vm.$apis.manage.userBehaviorStatistics(vm.userBehavior);
    });
  },
  destroy() {
    window.removeEventListener("scroll", vm.handleScroll, true);
  },
  methods: {
    getRegister() {
      var perId = this.$route.query.perId
      this.$apis.manage
      .getRegister({perId})
      .then((res) => {
        var data =[]
        if (res.resultCode == 200) {
          res.data.forEach(item=>{
            item.configJsons.forEach(item2=>{
              data.push(item2)
            })
          })
        }
        window.sessionStorage.setItem("getRegister", JSON.stringify(data));
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
    },
    handleScroll() {
      let scrolltop = this.getScroll().top;
      scrolltop > 30 ? (vm.gotop = true) : (vm.gotop = false);
      if (
        scrolltop / document.body.offsetHeight >= 0.8 &&
        !this.slidingOver80
      ) {
        this.slidingOver80 = true;
        this.userBehavior.slidingPercentage =
          (scrolltop / document.body.offsetHeight).toFixed(2) * 100;
        vm.$apis.manage.userBehaviorStatistics(this.userBehavior);
      }
    },
    //获得页面向左、向上卷动的距离
    getScroll() {
      return {
        // safari 比较特别，有自己获取scrollTop的函数 pageXOffset,pageYOffset
        // left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
        top:
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop,
      };
    },

    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            100;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    //公告接口调用
    annoud() {
      var data = {
        pageNo: 1,
        pageSize: 5,
        periodicalId: this.$store.state.qikanId,
        title: "",
      };
      vm.$apis.manage.Announ(data).then((res) => {
        vm.Announ_list = res.content.list.list;
        vm.Announ_list.map((item) => {
          item.createTime = item.createTime.replace(/-/g, "/").substring(0, 10);
        });
      });
    },

    // caibian() {
    //   var data = {
    //     pageNo: 1,
    //     pageSize: 10,
    //     perId: "1297783010043576320",
    //   };
    //   vm.$apis.manage.caibian(data).then((res) => {

    //   });
    // },
    delivst(id) {
      vm.$router.push({
        path: "/carDetails",
        query: {
          id: id,

          editId: this.$store.state.cbianId,
          perId: this.$store.state.qikanId,
        },
      });
    },

    cord_unit() {
      vm.$router.push({
        path: "/Bulletin",
        query: {
          editId: this.$store.state.cbianId,
          perId: this.$store.state.qikanId,
        },
      });
    },
  },
};
</script>
<style scoped>
.footer .gotop {
  text-align: center;
  position: fixed;
  right: 14%;
  bottom: 15%;
  cursor: pointer;
  padding: 10px;
  border-radius: 50%;
  width: 27px;
  height: 23px;
  color: #000000;
}
.economs {
  width: 100%;
  margin: 20px 0px;
  position: relative;
}

.flex_left {
  display: flex;
  justify-content: space-between;
}
.firstPage {
  margin: 0 auto;
}

.right_center {
  width: 600px;
  height: 305px;
  background: #ffffff;
  border: 1px solid #dcdcdc;
}

.center_anonco {
  width: 540px;
  margin: 0 auto;
  margin-top: 20px;
}
.git_anonco {
  border-bottom: 1px solid #bfbfbf;
  padding: 14px 0px;
}
.list_h3 h3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  text-indent: 0.5em;
}
.list_anonco li {
  width: 100%;
  list-style: none;
  border-bottom: 1px solid #d2d2d2;
  padding: 8px 0px 5px 0px;
}
.list_anonco li:last-child {
  border-bottom: none;
}
.left_anonco {
  position: relative;
  width: 70%;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  display: flex;
  justify-content: flex-start;
}
.left_anonco p {
  /* width: 50%; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.cen_anonco {
  width: 42px;
  height: 20px;
  text-align: center;
  line-height: 18px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  cursor: pointer;
  color: #333333;
  margin-top: 5px;
  margin-right: 10px;
  border: 1px solid #2150cb;
  border-radius: 4px;
}
.zix_anonco {
  border: 1px solid #ff900c;
}
.dt_anonco {
  border: 1px solid #21b1cb;
}
.right_anonco {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 30px;
}
.listGit img {
  display: block;
  width: 70%;
  height: 206px;
  margin: 3px auto;
}
.listGit {
  position: relative;
  width: 100%;
}
.listGit p {
  position: absolute;
  left: 45%;
  bottom: 15px;
  font-size: 14px;
  font-weight: normal;
  color: #666666;
  line-height: 30px;
}
</style>
